/* Carlow & Friends: hide only Tek Labs' oversized "You may also like" card.
 * YMAL and Free Gift app embeds remain enabled so the gift auto-add logic still runs.
 * Scoped to the drawer and avoids the separate compact extra-filters upsell.
 */
(() => {
  if (window.__carlowHideOldUpsellReady) return;
  window.__carlowHideOldUpsellReady = true;

  function normalise(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function removeLargeRecommendationVisual() {
    const cartRegion = document.querySelector('#CartDrawer .cart-drawer-items-and-upsell');
    if (!cartRegion) return;
    const possibleHeadings = cartRegion.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div');

    for (const heading of possibleHeadings) {
      if (normalise(heading.textContent) !== 'you may also like') continue;
      if (heading.closest('.carlow-compact-filters')) continue;
      // Prefer the deepest exact-match heading instead of a large container.
      if (Array.from(heading.children).some(child => normalise(child.textContent) === 'you may also like')) continue;

      let target = null;
      let ancestor = heading.parentElement;
      while (ancestor && ancestor !== cartRegion) {
        if (ancestor.matches('.carlow-compact-filters,cart-drawer-items')) break;
        if (ancestor.hasAttribute('data-carlow-hidden-old-ymal')) { target = ancestor; break; }
        const style = getComputedStyle(ancestor);
        const borderWidth = Math.max(
          parseFloat(style.borderTopWidth) || 0,
          parseFloat(style.borderBottomWidth) || 0,
          parseFloat(style.borderLeftWidth) || 0,
          parseFloat(style.borderRightWidth) || 0
        );
        const rect = ancestor.getBoundingClientRect();
        // The oversized widget has a full-width black rounded border.
        if (borderWidth >= 1 && rect.width > 180 && rect.height > 180) {
          target = ancestor;
          break;
        }
        ancestor = ancestor.parentElement;
      }
      if (target && !target.hasAttribute('data-carlow-hidden-old-ymal')) {
        target.setAttribute('data-carlow-hidden-old-ymal', '');
        target.setAttribute('aria-hidden', 'true');
        target.style.setProperty('display', 'none', 'important');
      }
    }
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      removeLargeRecommendationVisual();
    });
  }
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {childList: true, subtree: true, characterData: true});
})();
